import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {
  subjects as S,
  permissionTypes as T
} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import ModalContent from "../../../_common/components/ModalContent";
import {useAddEditItemContext} from "../../contexts/AddEditItemContext";
import {StyledFieldInput} from "../../../_common/components/FieldInput";
import {StyledFieldTextareaAutosize} from "../../../_common/components/FieldTextareaAutosize";
import {floatValue} from "../../../../../utils/format";

const PopupAddEditItem = () => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {formatMessage} = useIntl();
  const {id, isEdit, handleSubmit, formik, getItemDetails} = useAddEditItemContext();
  const {setFieldValue, values, handleChange, isValid} = formik;
  const prefix = 'price-catalog-page';
  const header = isEdit
    ? formatMessage({id: `${prefix}-edit-header`, defaultMessage: `Edit item ${id}`}, {id})
    : formatMessage({id: `${prefix}-create-new-header`, defaultMessage: `Create item`});
  const isDisabled = !can(T.FULL, S.PRICE_CATALOG_PAGE) || !id;

  return (
    <>
      {isEdit
        ? (
          <ButtonAction
            variant={'icon'}
            iconButtonType={'primary'}
            title={TTS.EDIT}
            disabled={isDisabled}
            onClick={async () => {
              await getItemDetails();
              handleShowModal();
            }}
            label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="e"/>}
            customClassnames={'mx-2'}
          />
        )
        : (
          <ButtonAction
            useIcon={'/media/common/Plus_white.svg'}
            label={formatMessage({id: `${prefix}-create-new`, defaultMessage: 'Create'})}
            disabled={isDisabled}
            onClick={handleShowModal}
          />
        )
      }
      <ModalContainer show={show} onHide={handleCloseModal}>
        <>
          <ModalHeader header={header}/>
          <ModalContent>
            <div className={'d-flex justify-content-between mb-4'}>
              <StyledFieldInput
                fieldId={'mainCategory'}
                value={values.mainCategory}
                label={
                  <div>
                    <span>{formatMessage({id: `${prefix}-edit-mainCategory`, defaultMessage: 'Main category'})}</span>
                    <span className={'text-danger'}>*</span>
                  </div> as unknown as string
                }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('mainCategory', e.target.value)}
                icon={'/media/common/Layers_primary.svg'}
                customContainerStyles={'w-100'}
              />
              <StyledFieldInput
                fieldId={'secondCategory'}
                value={values.secondCategory}
                label={
                  <div>
                    <span>{formatMessage({
                      id: `${prefix}-edit-secondCategory`,
                      defaultMessage: 'Second category'
                    })}</span>
                    <span className={'text-danger'}>*</span>
                  </div> as unknown as string
                }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('secondCategory', e.target.value)}
                icon={'/media/common/Layers_primary.svg'}
                customContainerStyles={'w-100 mx-4'}
              />
              <StyledFieldInput
                fieldId={'servicePrice'}
                value={values.servicePrice}
                label={
                  <div>
                    <span>{formatMessage({id: `${prefix}-edit-servicePrice`, defaultMessage: 'Service price'})}</span>
                    <span className={'text-danger'}>*</span>
                  </div> as unknown as string
                }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('servicePrice', floatValue(e))}
                icon={'/media/common/Money_primary.svg'}
                customContainerStyles={'w-75'}
              />
            </div>
            <StyledFieldInput
              fieldId={'serviceDescription'}
              value={values.serviceDescription}
              label={
                <div>
                  <span>{formatMessage({
                    id: `${prefix}-edit-serviceDescription`,
                    defaultMessage: 'Service description'
                  })}</span>
                  <span className={'text-danger'}>*</span>
                </div> as unknown as string
              }
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('serviceDescription', e.target.value)}
              icon={'/media/common/Description_primary.svg'}
              customContainerStyles={'w-100 mb-4'}
            />
            <StyledFieldTextareaAutosize
              fieldId={'notes'}
              label={formatMessage({id: `${prefix}-edit-notes`, defaultMessage: 'Notes'})}
              value={values.notes}
              onChange={handleChange}
            />
          </ModalContent>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              label={formatMessage({id: 'button-close', defaultMessage: 'Close'})}
              onClick={handleCloseModal}
              customClassnames={buttonCancel}
            />
            <ButtonAction
              label={formatMessage({id: 'button-submit', defaultMessage: 'Submit'})}
              useIcon={'/media/common/Check-in-circle_white.svg'}
              onClick={async () => {
                await handleSubmit();
                handleCloseModal();
              }}
              customClassnames={buttonSubmit}
              disabled={!isValid}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupAddEditItem;
